var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"teaching-score-confirm-title"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"scale"},[_vm._v("("+_vm._s(_vm.scale)+"%)")])])
}
var staticRenderFns = []

export { render, staticRenderFns }